var exports = {
  "X7": "UserProfileBadges.module__containerModal___bVZYRU",
  "j4": "UserProfileBadges.module__containerModalMobile___bVZYRU",
  "pP": "UserProfileBadges.module__containerModalDesktop___bVZYRU",
  "RS": "UserProfileBadges.module__containerPopout___bVZYRU",
  "Qk": "UserProfileBadges.module__badgeMobile___bVZYRU",
  "EJ": "UserProfileBadges.module__badgeDesktop___bVZYRU",
  "X8": "UserProfileBadges.module__sequenceBadge___bVZYRU",
  "Fi": "UserProfileBadges.module__sequenceBadgeMobile___bVZYRU",
  "Hd": "UserProfileBadges.module__sequenceBadgeDesktop___bVZYRU",
  "nf": "UserProfileBadges.module__link___bVZYRU",
  "$J": "UserProfileBadges.module__linkButton___bVZYRU",
};

module.exports = exports;
